import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

const Partners = (props) => {

    const data = props.data;

    return (
        <section className="tf-section partners">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center">
                     
                            <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Partners</h5>
                            <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">We Are Partnered <br /> With the BEST </h3>
                        </div>
                    </div>
                </div>
                
                   
                        <div className="partners__body" data-aos="fade-up">
                            {
                                data.map((data,index) => (
                                    <div key={index} className={`box-partner  ${data.border}`}>
                                        <a href="https://tcg.world" target="_blank"><img src={data.img} alt="TCGWorld" /></a>
                        

                                    </div>
                                ))
                            }
                            
                           
                        </div>
                    
                
            </div>
        </section>
    );
}

export default Partners;
